module.exports = __webpack_public_path__ + "img/icon_card014.5379a878.png";